var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrameGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 155,
    viewBox: "0 0 216 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22490",
    "data-name": "Rectangle 22490",
    width: 216,
    height: 155,
    rx: 6,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25751",
    "data-name": "Mask Group 25751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61172",
    "data-name": "Group 61172",
    transform: "translate(-518.907 -331.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46437",
    "data-name": "Group 46437",
    transform: "translate(518.027 332.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17172",
    "data-name": "Rectangle 17172",
    fill: "none",
    stroke: "#eaeaea",
    strokeWidth: 18
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217.771,
    height: 155.487,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 199.771,
    height: 137.487,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46483",
    "data-name": "Group 46483",
    transform: "translate(518 332.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994",
    "data-name": "Line 132994",
    d: "M14.176,18.5-.331.524l.565-.9L14.74,17.6Z",
    transform: "translate(3.616 -0.202)",
    fill: "rgba(138,138,138,0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-2",
    "data-name": "Line 132994",
    d: "M17.116-.375-.331,17.018l.679.869L17.795.495Z",
    transform: "translate(0.331 136.886)",
    fill: "rgba(138,138,138,0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-3",
    "data-name": "Line 132994",
    d: "M.284,18.142,16.094.507l-.615-.882L-.331,17.261Z",
    transform: "translate(199.675 0.38)",
    fill: "rgba(138,138,138,0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-4",
    "data-name": "Line 132994",
    d: "M.361-.375l17.779,17.6-.692.88L-.331.505Z",
    transform: "translate(199.674 136.79)",
    fill: "rgba(138,138,138,0.38)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameGrey);
export default __webpack_public_path__ + "static/media/frame_grey.4ca940eed04332ba5b51df21b754dfb0.svg";
export { ForwardRef as ReactComponent };